module.exports = __webpack_public_path__ + "img/menu.ca394ec8.svg";